const createMapStore = (set) => ({
  center: null,
  markers: null,
  clickedLayer: null,
  setMarkers: (value) => set(() => ({ markers: value })),
  setCenter: (value) => set(() => ({ center: value })),
  setClickedLayer: (value) =>
    set((state) => {
      if (!state.clickedLayer) return { clickedLayer: value };
      if (state.clickedLayer.vehiclePlate === value.vehiclePlate) {
        return { clickedLayer: null };
      }
      return { clickedLayer: value };
    }),

  setNullClickedLayer: () => set(() => ({ clickedLayer: null })),
});

export default createMapStore;
